import CreateThankYou from './CreateThankYou';

export default CreateThankYou;
